import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "../../assets/scss/details/listApprovedModal.scss";
import {
  LdsButton,
  LdsModal,
  LdsLoadingSpinner,
  LdsIcon,
} from "@elilillyco/ux-lds-react";
import Select from "react-select";
const ListApprovedModal = ({
  isListAppModalOpen,
  setListAppModalOpen,
  msg,
  setMsg,
  updateSpecialityDetails,
  addedSpecialtyCodes,
  uncommonRespCodes,
  delSpecialtyCodes,
  department,
  quarter
}) => {
  const thead = [
    "Specialty Code",
    "Specialty Description",
    "Incentivized",
    "Responsibility Code",
    "Status",
  ];
  const theadSf = ["Specialty Code", "Specialty Description", "Status"];
  const [allChanges, setAllChanges] = useState([]);
  const [userOptions, setuserOptions] = useState([]);
  const [approverOptions, setApproverOptions] = useState([]);
  const [selectedapprovers, setselectedapprovers] = useState([]);
  const [selectedApproverUsers, setSelectedApproverUsers] = useState([]);
  const { userTableList, loading } = useSelector(({ admin }) => admin);
  
  // Determine if this is the combined reviewer+approver selection (MLR submission from DRAFT)
  const isMLRSubmission = msg === "Are you sure want to request for Review ?" && !quarter;
  
  useEffect(() => {
    if (msg === "Are you sure want to request for Review ?") {
      // Reviewer options
      setuserOptions(
        userTableList
          .filter((value) => {
            if (value.active) {
              if (quarter) {
                return value.role === "spclty_hub_incentivized_approver";
              } else {
                return value.role === "spclty_hub_mlr_reviewer";
              }
            } else {
              return null;
            }
          })
          .map((value) => {
            return {
              label:
                value.first_name +
                " " +
                value.last_name +
                " (" +
                value.email_id +
                ")",
              value: value.uuid,
            };
          })
      );
      // For MLR lists: also populate approver options at the same time
      if (!quarter) {
        setApproverOptions(
          userTableList
            .filter((value) => {
              if (value.active) {
                return value.role === "spclty_hub_mlr_approver";
              } else {
                return null;
              }
            })
            .map((value) => {
              return {
                label:
                  value.first_name +
                  " " +
                  value.last_name +
                  " (" +
                  value.email_id +
                  ")",
                value: value.uuid,
              };
            })
        );
      }
    } else {
      setuserOptions(
        userTableList
          .filter((value) => {
            if (value.active) {
              if (quarter) {
                return value.role === "spclty_hub_incentivized_approver"; 
              }
              return value.role === "spclty_hub_mlr_approver";
            } else {
              return null;
            }
          })
          .map((value) => {
            return {
              label:
                value.first_name +
                " " +
                value.last_name +
                " (" +
                value.email_id +
                ")",
              value: value.uuid,
            };
          })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userTableList, msg, department]);
  
  const returnOverview = () => {
    setselectedapprovers([]); // Clear selected reviewers
    setSelectedApproverUsers([]); // Clear selected approvers
    setListAppModalOpen(false);
  };
  
  // Handle modal close from X button or clicking outside
  const handleModalClose = (isOpen) => {
    if (!isOpen) {
      setselectedapprovers([]); // Clear selected reviewers
      setSelectedApproverUsers([]); // Clear selected approvers
    }
    setListAppModalOpen(isOpen);
  };
  
  const handleApproverChange = (selectedOptions) => {
    setselectedapprovers(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };
  
  const handleApproverUsersChange = (selectedOptions) => {
    setSelectedApproverUsers(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };
  
  const handleSelectAll = () => {
    setselectedapprovers(userOptions.map(option => option.value));
  };
  
  const handleUnselectAll = () => {
    setselectedapprovers([]);
  };
  
  const handleToggleSelectAll = () => {
    if (selectedapprovers.length === userOptions.length) {
      handleUnselectAll();
    } else {
      handleSelectAll();
    }
  };
  
  const handleSelectAllApprovers = () => {
    setSelectedApproverUsers(approverOptions.map(option => option.value));
  };
  
  const handleUnselectAllApprovers = () => {
    setSelectedApproverUsers([]);
  };
  
  const handleToggleSelectAllApprovers = () => {
    if (selectedApproverUsers.length === approverOptions.length) {
      handleUnselectAllApprovers();
    } else {
      handleSelectAllApprovers();
    }
  };
  
  const getToggleButtonText = () => {
    return selectedapprovers.length === userOptions.length ? "Unselect All" : "Select All";
  };
  
  const getToggleApproverButtonText = () => {
    return selectedApproverUsers.length === approverOptions.length ? "Unselect All" : "Select All";
  };
  
  // Custom styles for react-select to match LDS theme
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '40px',
      borderColor: state.isFocused ? '#0071ce' : '#ccc',
      boxShadow: state.isFocused ? '0 0 0 1px #0071ce' : 'none',
      '&:hover': {
        borderColor: '#0071ce'
      }
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#e6f2ff',
      borderRadius: '4px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#0071ce',
      fontWeight: '500',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#0071ce',
      ':hover': {
        backgroundColor: '#0071ce',
        color: 'white',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#0071ce' : state.isFocused ? '#e6f2ff' : 'white',
      color: state.isSelected ? 'white' : '#333',
      '&:active': {
        backgroundColor: '#0071ce',
      },
    }),
  };
  
  useEffect(() => {
    if (
      (delSpecialtyCodes.length > 0 &&
        (msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?")) ||
      (addedSpecialtyCodes.length > 0 &&
        (msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?")) ||
      (uncommonRespCodes.length > 0 && (msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?"))
    ) {
      setAllChanges([
        ...addedSpecialtyCodes,
        ...uncommonRespCodes,
        ...delSpecialtyCodes,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delSpecialtyCodes, addedSpecialtyCodes, uncommonRespCodes]);
  const confirmSubmission = () => {
    // For MLR submission from DRAFT: pass both reviewers and approvers
    if (isMLRSubmission) {
      updateSpecialityDetails(selectedapprovers, selectedApproverUsers);
    } else {
      updateSpecialityDetails(selectedapprovers);
    }
  };
  const showTable = () => {
    if (
      (delSpecialtyCodes.length > 0 &&
        (msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?")) ||
      (addedSpecialtyCodes.length > 0 &&
        (msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?")) ||
      (uncommonRespCodes.length > 0 && (msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?"))
    ) {
      return true;
    }
    return false;
  };
  const getTableColumn = () => {
    if (sessionStorage.getItem("role") === "spclty_hub_mlr_approver" || sessionStorage.getItem("role") === "spclty_hub_mlr_reviewer") {
      return theadSf;
    }
    return thead;
  };
  const checkIncenApproverRole = () => {
    const role = sessionStorage.getItem("role");
    if (role === "spclty_hub_incentivized_approver" || role === "spclty_hub_super_admin") {
      return true;
    }
    return false;
  };
  const noUpdates = () => {
    if ((msg === "Are you sure want to approve ?" || msg === "Are you sure you want to Submit Review ?") && allChanges.length === 0) {
      return true;
    }
    return false;
  };
  return (
    <>
      <LdsModal
        modalId="list-app-modal"
        open={isListAppModalOpen}
        setModalOpen={handleModalClose}
        // heading="Add Specialty"
      >
        <div>
          <div className="icon-size">
            <LdsIcon
              name="CheckCircleFill"
            />
          </div>
          {/* <h1>Inside List Approved Modal</h1> */}
          <div className="msg-data">
            <h2>{msg}</h2>
          </div>
          {msg === "Are you sure want to request for approval ?" && (
            <div className="msg-data">
              <div className="approver-selection-section">
                <div className="selection-header">
                  <label className="selection-label">
                    Select Approvers <span className="required-asterisk">*</span>
                  </label>
                  <LdsButton 
                    linkButton 
                    onClick={handleToggleSelectAll}
                    disabled={loading || userOptions.length === 0}
                  >
                    {getToggleButtonText()}
                  </LdsButton>
                </div>
                {!loading ? (
                  <Select
                    isMulti
                    options={userOptions}
                    value={userOptions.filter(option => selectedapprovers.includes(option.value))}
                    onChange={handleApproverChange}
                    placeholder="Search and select approvers by name or email..."
                    styles={customSelectStyles}
                    isClearable
                    isSearchable
                    closeMenuOnSelect={true}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                ) : (
                  <LdsLoadingSpinner size={40} />
                )}
                {selectedapprovers.length > 0 && (
                  <div className="selection-count">
                    {selectedapprovers.length} approver{selectedapprovers.length !== 1 ? 's' : ''} selected
                  </div>
                )}
              </div>
            </div>
          )}
          {msg === "Are you sure want to request for Review ?" && (
            <div className="msg-data">
              <div className="approver-selection-section">
                <div className="selection-header">
                  <label className="selection-label">
                    Select Reviewers <span className="required-asterisk">*</span>
                  </label>
                  <LdsButton 
                    linkButton 
                    onClick={handleToggleSelectAll}
                    disabled={loading || userOptions.length === 0}
                  >
                    {getToggleButtonText()}
                  </LdsButton>
                </div>
                {!loading ? (
                  <Select
                    isMulti
                    options={userOptions}
                    value={userOptions.filter(option => selectedapprovers.includes(option.value))}
                    onChange={handleApproverChange}
                    placeholder="Search and select reviewers by name or email..."
                    styles={customSelectStyles}
                    isClearable
                    isSearchable
                    closeMenuOnSelect={true}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                ) : (
                  <LdsLoadingSpinner size={40} />
                )}
                {selectedapprovers.length > 0 && (
                  <div className="selection-count">
                    {selectedapprovers.length} reviewer{selectedapprovers.length !== 1 ? 's' : ''} selected
                  </div>
                )}
              </div>
              {/* For MLR lists: also select approvers at the same time */}
              {isMLRSubmission && (
                <div className="approver-selection-section" style={{marginTop: '16px'}}>
                  <div className="selection-header">
                    <label className="selection-label">
                      Select Approvers <span className="required-asterisk">*</span>
                    </label>
                    <LdsButton 
                      linkButton 
                      onClick={handleToggleSelectAllApprovers}
                      disabled={loading || approverOptions.length === 0}
                    >
                      {getToggleApproverButtonText()}
                    </LdsButton>
                  </div>
                  {!loading ? (
                    <Select
                      isMulti
                      options={approverOptions}
                      value={approverOptions.filter(option => selectedApproverUsers.includes(option.value))}
                      onChange={handleApproverUsersChange}
                      placeholder="Search and select approvers by name or email..."
                      styles={customSelectStyles}
                      isClearable
                      isSearchable
                      closeMenuOnSelect={true}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  ) : (
                    <LdsLoadingSpinner size={40} />
                  )}
                  {selectedApproverUsers.length > 0 && (
                    <div className="selection-count">
                      {selectedApproverUsers.length} approver{selectedApproverUsers.length !== 1 ? 's' : ''} selected
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {showTable() ? (
            <div className="summary-table-wrapper">
              <table className="summary-changes-table">
                <thead>
                  <tr>
                    {getTableColumn().map((itm, index) => (
                      <th key={index}>{itm}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allChanges.map((table, index) => (
                    <tr key={table.specialty_code || index} className={table.status}>
                      <td>{table.specialty_code}</td>
                      <td>{table.specialty_description}</td>
                      {checkIncenApproverRole() ? (
                        <td>{table.incentivized ? "Yes" : "No"}</td>
                      ) : (
                        <></>
                      )}
                      {checkIncenApproverRole() ? (
                        <td>{table.responsibility_code}</td>
                      ) : (
                        <></>
                      )}
                      <td>{table.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <></>
          )}
          {noUpdates() ? (
            <div className="mrgn">
              {" "}
              <h3>No updates were made to existing list.</h3>
            </div>
          ) : (
            <></>
          )}
          <div className="row">
            <div className="col">
              <span className="floatRight mt-4">
                <span className="mr-4">
                  <LdsButton
                    // icon="Plus"
                    // iconPosition="before"
                    classes="button-icon-left blue-bdr-btn"
                    onClick={returnOverview}
                  >
                    No
                  </LdsButton>
                </span>
                <LdsButton
                  // icon="Plus"
                  // iconPosition="before"
                  classes="button-icon-left blue-btn"
                  onClick={confirmSubmission}
                  disabled={
                    (selectedapprovers.length === 0 &&
                    msg !== "Are you sure want to approve ?" &&
                    msg !== "Are you sure you want to approve this list?" &&
                    msg !== "Are you sure you want to Submit Review ?") ||
                    (isMLRSubmission && selectedApproverUsers.length === 0)
                  }
                >
                  Yes
                </LdsButton>
              </span>
            </div>
          </div>
        </div>
      </LdsModal>
    </>
  );
};
export default ListApprovedModal;
